import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_SUPPLY_CHAIN: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateSupplyChain($input: UpdateSupplyChainInput!) {
    updateSupplyChain(input: $input) {
      supplyChain {
        name
        id
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
